/* jshint esversion: 6 */
import React from 'react';
import InputEditorWrapper from 'app/mixins/InputEditorWrapper.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import Toggle from 'app/components/common/ToggleControl.jsx';
import ScheduleComponent from 'app/components/EditorComponents/ScheduleComponent.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import { compose } from 'redux';
import * as _ from 'underscore';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class InputUpdatePanel extends React.Component {
	constructor(props) {
		super(props);

		this.createSchedule = this.createSchedule.bind(this);
		this.onFreqUpgradeClick = this.onFreqUpgradeClick.bind(this);

	}

	createSchedule() {

		this.props.scheduleHandler('add');

	}

	onFreqUpgradeClick(e) {

		e.preventDefault();
		this.props.showUpgradeModal(this.props.closeAllModals, 'pullFreq', null, 'input_edit');

	}

	render() {
		let updateFrequency = (this.props.input.pullFreq) ? this.props.input.pullFreq : 30,
			maxPerUpdate = (this.props.input.numItems) ? this.props.input.numItems : '',
			maxPerDay = (this.props.input.postLimit) ? this.props.input.postLimit : '',
			trickleOption = (this.props.input.itemTrickle) ? this.props.input.itemTrickle : 0,
			pushEnabled = (this.props.input.pushEnabled && (parseInt(this.props.input.pushEnabled, 10) || this.props.input.pushEnabled === true)) ? true : false,
			updateFreqs = [],
			trickleOptions = [],
			schedules = (this.props.input.sched) ? this.props.input.sched : [],
			upgradePrompt = null,
			constants = this.props.app.config.constants,
			scheduleBlock = null,
			push = '',
			rawFreqList = (this.props.user.perms.resources.pullFrequencyList) ? this.props.user.perms.resources.pullFrequencyList : [];

		if (this.props.input && this.props.input.type === constants.INPUT_TYPE_TWITTER) {
			if (this.props.isAgencyUser() || this.props.isPlusUser() || this.props.isAgencyPlusUser()) {
				rawFreqList = _.filter(rawFreqList, (freq) => {
					return freq >= 5;
				});
			} else {
				rawFreqList = _.filter(rawFreqList, (freq) => {
					return freq >= 15;
				});
			}
		}

		if (rawFreqList) {
			updateFreqs = rawFreqList.map(function(freq, i){
				var label = "Once a day";
				if (freq < 60) {
					label = "Every " + freq + " minutes";
				} else if (freq >= 60 && freq < 1440) {
					if (freq/60 == 1) {
						label = "Every hour";
					} else {
						label = "Every " + freq/60 + " hours";
					}

				}
				return ({value: freq, label: label});
			});
		}

		trickleOptions = [
			{value: 0, label: 'Trickle Off'},
			{value: 1, label: 'Post Newest Items First'},
			{value: 2, label: 'Post Oldest Items First'},
			{value: 3, label: 'Randomize Item Order'},
		];

		if (this.props.isFreeUser()) {
			upgradePrompt = (
				<div className="upgrade-inline">
					<a href="#" onClick={this.onFreqUpgradeClick}>Unlock</a> faster updates
				</div>
			);
		}

		if (this.props.app.flags.routeViewType == constants.ROUTE_VIEW_ADVANCED) {
			scheduleBlock = (
				<fieldset>
					<legend>Update Window<HelpButton which="updateWindow"/></legend>
					<ErrorModule
						app={this.props.app}
						keys={['INPUT_CREATE', 'INPUT_UPDATE']}
						render={(state) => {
							return (
								<FieldError field="sched" errors={state.errors}/>
							);
						}}/>
					<div className="new-schedule-button" onClick={this.createSchedule} role="button" aria-label="add window">
						Add Window
					</div>
					{schedules.map(function(schedule, i){
						return (
							<ScheduleComponent
								{...this.props}
								key={schedule.s_id}
								schedule={schedule}
								updateHandler={this.props.scheduleHandler} />
						);
					}, this)}
				</fieldset>
			);
		}

		if(this.props.input.type !== constants.INPUT_TYPE_TWITTER) {
			if (this.props.isFreeUser()) {
				push = (
					<fieldset>
						<legend>Subscribe to PuSH Updates<HelpButton which="pushEnabled"/></legend>
						<Toggle active={false}
								noLabel={true}
								callback={() => {
									this.props.showUpgradeModal(this.props.closeAllModals, 'pushUpdates', null, 'input_edit')
								}}
								linkedField={this.props.statePath + ".pushEnabled"} />
					</fieldset>
				);
			} else {
				push = (
					<fieldset>
						<legend>Subscribe to PuSH Updates<HelpButton which="pushEnabled"/></legend>
						<ErrorModule
							app={this.props.app}
							keys={['INPUT_CREATE', 'INPUT_UPDATE']}
							render={(state) => {
								return (
									<FieldError field="pushEnabled" errors={state.errors}/>
								);
							}}/>
						<Toggle active={pushEnabled}
								noLabel={true}
								callback={this.props.changeHandler}
								linkedField={this.props.statePath + ".pushEnabled"} />
					</fieldset>
				);
			}
		}

		return (
			<div className="editor-panel">
				<form>
					<fieldset>
						<legend>Update Frequency</legend>
						<ErrorModule
							app={this.props.app}
							keys={['INPUT_CREATE', 'INPUT_UPDATE', 'INPUT_VALIDATE']}
							render={(state) => {
								return (
									<FieldError field="pullFreq" errors={state.errors}/>
								);
							}}/>
						<StyledSelect options={updateFreqs}
										value={updateFrequency}
										linkedField={this.props.statePath + '.pullFreq'}
										onChange={this.props.changeHandler}
										selectClass="small" />
						{upgradePrompt}
					</fieldset>
					<fieldset>
						<legend>Max posts per update <span className="required">*</span></legend>
						<ErrorModule
							app={this.props.app}
							keys={['INPUT_CREATE', 'INPUT_UPDATE']}
							render={(state) => {
								return (
									<FieldError field="numItems" errors={state.errors}/>
								);
							}}/>
						<UncontrolledTextInput
							className="text-input x-small"
							defaultValue={maxPerUpdate}
							onChange={this.props.changeHandler}
							data-field={this.props.statePath + ".numItems"} />
					</fieldset>
					<fieldset>
						<legend>Max posts per day <span className="required">*</span></legend>
						<ErrorModule
							app={this.props.app}
							keys={['INPUT_CREATE', 'INPUT_UPDATE']}
							render={(state) => {
								return (
									<FieldError field="postLimit" errors={state.errors}/>
								);
							}}/>
						<UncontrolledTextInput
							className="text-input x-small"
							defaultValue={maxPerDay}
							onChange={this.props.changeHandler}
							data-field={this.props.statePath + ".postLimit"} />
					</fieldset>
					<fieldset>
						<legend>Trickle<HelpButton which="itemTrickle"/></legend>
						<ErrorModule
							app={this.props.app}
							keys={['INPUT_CREATE', 'INPUT_UPDATE']}
							render={(state) => {
								return (
									<FieldError field="itemTrickle" errors={state.errors}/>
								);
							}}/>
						<StyledSelect options={trickleOptions}
										value={trickleOption}
										linkedField={this.props.statePath + ".itemTrickle"}
										onChange={this.props.changeHandler}
										selectClass="med"/>
					</fieldset>
					{push}
					{scheduleBlock}
				</form>
			</div>
		);
	}
};

InputUpdatePanel.displayName = "InputUpdatePanel";

const enhance = compose(
	ComponentWithContext,
	InputEditorWrapper
);

export default enhance(InputUpdatePanel);
